<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="审核中" name="0"></el-tab-pane>
            <el-tab-pane label="通过审核" name="1"></el-tab-pane>
            <el-tab-pane label="审核未通过" name="2"></el-tab-pane>
            <el-tab-pane label="上架中" name="3"></el-tab-pane>
            <el-tab-pane label="已下架" name="4"></el-tab-pane>
        </el-tabs>
        <div class="list-content" v-loading="loading">
            <div class="list-head">
                <div class="f-14 color-grays"></div>
                <el-button type="primary" size="mini" @click="$router.push({path:'/center/addCar'})">添加车辆+</el-button>
            </div>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shuttleManage",
        data() {
            return {
                activeName: '0',
                loading: false,
                list: []
            }
        },
        created() {
            this.driverCarIndex();
        },
        methods: {
            handleClick() {
                this.driverCarIndex();
            },
            async driverCarIndex(){
                let param = {};
                if(this.activeName<=2){
                    param.is_state = this.activeName;
                }else{
                    param.is_shelves = this.activeName - 2;
                }
                let [e, data] = await this.$api.driverCarIndexApi(param)
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content {
        width: 100%;

        .list-head {
            width: 100%;
            height: 54px;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }
    }
</style>
